export default __webpack_public_path__ + "static/media/deloitte.42e82577.png";